import { LeadSourceDTO } from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["hostedApiLead"] as QueryKey,
  listSources: () => [...keys.all(), "listSources"] as QueryKey,
};

export const hostedApiLead = {
  keys,
  queries: {},
  infiniteQueries: {
    listSources: () =>
      infiniteQueryOptions({
        queryKey: keys.listSources(),
        queryFn: async () => {
          return (await api.get<LeadSourceDTO[]>("/hosted/lead/source")).data;
        },
        getNextPageParam: () => undefined,
        initialPageParam: undefined,
      }),
  },
  mutations: {},
};
